// frontend/src/app/claim-annotator/ports/annotation-repository.port.ts
import { InjectionToken } from '@angular/core';
import { AnnotationRow } from '../domain/types';

export interface AnnotationRepository {
  loadFor(documentId: string): Promise<AnnotationRow[]>;
  /**
   * Submit the full set of annotations for a document. Replaces whatever the
   * repository previously held for that document with the provided snapshot.
   * Throws on failure; callers should expect to catch and surface errors.
   */
  submitAll(documentId: string, annotations: readonly AnnotationRow[]): Promise<void>;
  /**
   * Remove all stored state for a document. Called when the document is deleted
   * locally so the backing store doesn't retain orphaned data.
   */
  delete(documentId: string): Promise<void>;
  /**
   * Run OCR on a box annotation and return the updated row with ocr_text populated.
   * The annotation data is sent to the backend so it can create the annotation if
   * it hasn't been saved yet (avoiding ordering issues between local creation and
   * backend persistence).
   * The documentId uses the `paper:{id}` prefix (e.g. "paper:42").
   */
  runOcr(documentId: string, annotation: AnnotationRow): Promise<AnnotationRow>;
}

export const ANNOTATION_REPOSITORY = new InjectionToken<AnnotationRepository>(
  'ANNOTATION_REPOSITORY',
);
